module.exports = __webpack_public_path__ + "img/debut-stream.9e03daa2.webp";